import CloudEvent from '../../services/api/CloudEvents/CloudEvent';
import { DATA_OBJ_EVENT_TYPES, EVENT_SOURCE } from '../../services/api/CloudEvents/constants';
import { getPositionObject, getSubject } from '../../services/api/CloudEvents/CloudEventsApi';
import { CONTROLS, PAGES, PLACEMENTS, SLOTS, TYPES } from './constants';

export default class ProductDialogATCEvent extends CloudEvent {
  constructor({
    userId,
    orderId,
    merchantId,
    itemId,
    idSeam,
    sessionId,
    upsellId,
    clientX,
    clientY,
  }) {
    const subjectParams = {
      userId, orderId, merchantId,
    };
    super(
      EVENT_SOURCE,
      TYPES.PRODUCT_DIALOG_ATC,
      getSubject(subjectParams),
      idSeam,
    );
    const data = {
      sessionID: sessionId,
      uxContext: {
        page: PAGES.PRODUCT_DIALOG,
        slot: SLOTS.FOOTER,
        placement: PLACEMENTS.PRODUCT_CALL_TO_ACTION_PLACEMENT,
        control: CONTROLS.ADD_TO_CART_BUTTON,
      },
      position: getPositionObject({ clientX, clientY }),
      itemId,
      ...(upsellId && { upsellId }),
      eventType: DATA_OBJ_EVENT_TYPES.CLICK,
    };
    this.setData(data);
  }
}
